<template>
<v-layout wrap class='px-3 mb-3'>
  <v-flex xs12 >
    <v-text-field persistent-hint clearable
      v-model='localpassword'
      label='Password'
      hint='The password your client needs to use to access this invoice' />
    <v-chip @click='localpassword=relIdNumber;localpasswordHint="Use your ID number to unlock the pdf"' label small v-if='relIdNumber' >{{relIdNumber}}</v-chip>
    <v-chip @click='localpassword=relEmail;localpasswordHint="Use your email address to unlock the pdf"' label small v-if='relEmail' >{{relEmail}}</v-chip>
    <v-chip @click='localpassword=relPhone;localpasswordHint="Use your 12 digit phone number starting with + to unlock the pdf"' label small v-if='relPhone' >{{relPhone}}</v-chip>
  </v-flex>
  <template v-if='localpassword' >
    <v-flex >
      <v-text-field persistent-hint clearable
        v-model='localpasswordHint'
        label='Password hint' class='caption'
        hint='You can add a hint to help your client know what password to use' />
    </v-flex>
    <v-flex xs12 >
      <p class='amber lighten-3 pa-1 mt-2' >
        <v-icon small >warning</v-icon> Encrypted PDFs may effect the delivery of your emails
      </p>
    </v-flex>
  </template>
</v-layout>
</template>
<script>
export default {
  name: 'Encrypt',
  props: {
    password: { type: String, required: false },
    passwordHint: { type: String, required: false },
    relationship: { type: Object, required: false }
  },
  data () {
    return {
      localpassword: null,
      localpasswordHint: null
    }
  },
  watch: {
    password: {
      immediate: true,
      handler () {
        this.localpassword = this.password
      }
    },
    passwordHint: {
      immediate: true,
      handler () {
        this.localpasswordHint = this.passwordHint
      }
    },
    localpassword () { this.$emit('update:password', this.localpassword) },
    localpasswordHint () { this.$emit('update:passwordHint', this.localpasswordHint) }
  },
  computed: {
    relIdNumber () {
      return this.getObjectPath(this.relationship, 'record.medical_aid.patient_id_number')
    },
    relEmail () {
      let email = this.getObjectPath(this.relationship, 'client.email')
      if (this.isRealEmail(email)) { return email }
      email = this.getObjectPath(this.relationship, 'email')
      if (this.isRealEmail(email)) { return email }
      return null
    },
    relPhone () {
      let ph = this.getObjectPath(this.relationship, 'client.phone_number')
      if (ph) { return ph }
      ph = this.getObjectPath(this.relationship, 'phone_number')
      if (ph) { return ph }
      return null
    }
  }
}
</script>



// WEBPACK FOOTER //
// encrypt.vue?2d0a32a2